export default {
  creditPacks: {
    'freePlan': [],
    'paidPlan': []
  }
}
